import { object, string, mixed } from 'yup';
import HttpStatus from 'http-status-codes';

// TODO: need to handle this err type properly
export const SchemaError = {
  [HttpStatus.BAD_REQUEST]: {
    email: 'Email already used'
  }
};

export default object().shape({
  firstName: string().required('First name is required'),
  lastName: string().required('Last name is required'),
  email: string()
    .required('Email is required')
    .email('Invalid email address'),
  phone: string().required('Phone Number is required'),
  role: string().required('Role is required'),
  internalNotes: string().when('role', {
    is: 'property_manager',
    then: string().required('Internal Note is required'),
    otherwise: string().nullable()
  }),
  status: string().when('role', {
    is: 'house_keeper',
    then: string().required('Status is required'),
    otherwise: string().nullable()
  }),
  regionID: string().when('role', {
    is: 'house_keeper',
    then: string().required('Please select region'),
    otherwise: string().nullable()
  }),
  activeAt: mixed().when(['role', 'status'], {
    is: (role, status) => role === 'house_keeper' && status === 'inactive',
    then: object().required('Active date is required')
  })
});
